import React, { Suspense } from 'react';
import {
	useCustomUITunnelsListRelay,
	type UseAppTunnelsRelayOptions,
} from '../../web-client/hooks/useCustomUITunnelsList';
import { RelayErrorBoundary } from '../../error-boundary/RelayErrorBoundary';
import type { GQLCustomUITunnelDefinition } from '../../web-client/graphql/types';

interface TunnelResult {
	loading: boolean;
	tunnels: GQLCustomUITunnelDefinition[];
}

interface TunnelsProviderProps extends UseAppTunnelsRelayOptions {
	children: (result: TunnelResult) => React.ReactElement;
}


const TunnelsLoader = ({
	appId,
	contextIds,
	environmentId,
	children,
}: TunnelsProviderProps) => {
	const { tunnels } = useCustomUITunnelsListRelay({
		appId,
		environmentId,
		contextIds,
	});

	return children({ loading: false, tunnels });
};

export const TunnelsProvider = ({
	appId,
	contextIds,
	environmentId,
	children,
}: TunnelsProviderProps) => {
	const fallbackResult: TunnelResult = { tunnels: [], loading: true };

	return (
		<RelayErrorBoundary fallback={children({ tunnels: [], loading: false })}>
			<Suspense fallback={children(fallbackResult)}>
				<TunnelsLoader
					appId={appId}
					contextIds={contextIds}
					environmentId={environmentId}
					children={children}
				/>
			</Suspense>
		</RelayErrorBoundary>
	);
};
